export enum ComponentType {
    OpenComponent,
    InventoryComponent,
    ListComponent
}
